/*
 * This file is generated by icons/template.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, CommonProps } from '../constants';
import theme from '../theme';
import sizeStyle, { IconSizeProps } from '../lib/iconSize';

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 512 512" {...props}>
    <path
      d="M387.192 22.24l48.07 25.767a9.586 9.586 0 014.243 12.319l-43.945 99.683a9.752 9.752 0 01-.068.158L323.74 322.864a9.608 9.608 0 01-1.47 2.348 9.573 9.573 0 01-2.87 3.705l-45.456 35.692a9.582 9.582 0 01-4.09 1.894 9.579 9.579 0 01-6.404 1.139c-61.169-10.435-125.205.318-159.055 21.043-10.722 6.564-13.137 10.537-12.902 10.801 3.773 4.232 21.256 6.997 49.98 4.988 62.373-4.366 96.49 3.37 92.097 28.07-3.36 18.894-37.458 38.968-93.983 58.094-5.026 1.7-10.48-.99-12.18-6.01-1.701-5.018.995-10.466 6.021-12.167 26.028-8.807 47.035-17.893 61.6-26.468 12.437-7.322 19.081-13.758 19.621-16.797.035-.194-1.977-1.88-10.858-3.893-12.898-2.925-33.57-3.603-60.983-1.684-34.485 2.412-56.488-1.069-65.67-11.368-11.498-12.898-2.35-27.945 17.218-39.927 36.292-22.22 100.713-33.75 163.627-24.95l-2.188-51.371a9.563 9.563 0 012.271-6.617c.006-.01.01-.022.016-.033l3.91-8.868a9.62 9.62 0 011.294-2.933l66.518-150.84.019-.043 30.835-69.915c-8.101-3.72-17.05-.36-20.729 7.977l-44.019 99.823c-2.14 4.852-7.81 7.056-12.665 4.923a9.586 9.586 0 01-4.917-12.648l44.02-99.825c7.994-18.118 28.35-25.783 46.06-17.822l5.445-12.348c2.26-5.122 8.406-7.24 13.34-4.594zM276.027 296.25l-.364.827c-.162.368-.345.72-.545 1.058l1.694 39.816 29.497-23.163.82-1.859-31.102-16.679zm67.188-152.357L283.8 278.626l31.102 16.68 59.423-134.737-31.109-16.675zm44.037-99.849l-36.258 82.212 31.107 16.674 36.246-82.218-31.095-16.668z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
);

type Props = CommonProps & IconSizeProps;
const IconPencil = styled(SvgComponent)<Props>`
  ${sizeStyle}
  ${COMMON}
`;
IconPencil.defaultProps = {
  theme,
};
IconPencil.propTypes = { ...sizeStyle.propTypes, ...COMMON.propTypes, theme: PropTypes.object };
IconPencil.displayName = 'IconPencil';
export { IconPencil };
